import { useEffect, useRef, useState } from 'react';
import { borrarPantallaRol, getPantallasByRol, getPermisosByRol, getPermisosPan, getRolesOpem, guardaPantallaRol, guardarPermisos } from '../../services/Roles/RolesService';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import BorradoPantalla from './BorradoPantalla';
import AdicionPantalla from './AdicionPantalla';

const PermisosRoles = () => {
    const [rol, setRol] = useState();
    const [lstRoles, setLstRoles] = useState([]);
    const [cargaRoles, setCargaRoles] = useState(false);

    const [permisos, setPermisos] = useState();
    const [lstPermisos, setLstPermisos] = useState([]);
    const [cargaPermisos, setCargaPermisos] = useState(false);

    const [pantallas, setPantallas] = useState([]);
    const [permisosBase, setPermisosBase] = useState([])
    const [permisosInicio, setPermisosInicio] = useState();
    const [permisosActuales, setPermisosActuales] = useState([]);
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [loadingBorrar, setLoadingBorrar] = useState(false);

    const [visibleBorrado, setVisibleBorrado] = useState(false)
    const [visibleAdicion, setVisibleAdicion] = useState(false)

    const [filaSeleccion, setFilaSeleccion] = useState();

    const [refrescaRol, setRefrescaRol] = useState(false)

    // Filas expandidas del DataTable. Se expanden para mostrar los BLOQUE_* de la pantalla.
    const [expandedRows, setExpandedRows] = useState(null)

    const toast= useRef()

    // Extrae la lista de bloques declarados en el parametro JSON de una pantalla.
    // El formato esperado es {"...","bloques":"BLOQUE_A;BLOQUE_B"} (separados por ";"
    // para no romper el parser simple que se usa tambien en el backend).
    const extraerBloques = (parametroStr) => {
        if (!parametroStr) return [];
        try {
            const match = parametroStr.match(/"bloques"\s*:\s*"([^"]*)"/);
            if (!match) return [];
            return match[1].split(';').map(s => s.trim()).filter(Boolean);
        } catch (e) {
            return [];
        }
    };

    useEffect(() => {
        const recuperaRoles = async () => {
            try {
                setCargaRoles(true);
                const roles = await getRolesOpem();
                //console.log('XX01:', roles)
                setLstRoles(roles);
            } catch (error) {
                console.error('ERROR: ', error.message);
            } finally {
                setCargaRoles(false);
            }
        };
        recuperaRoles();
    }, []);

    useEffect(() => {
        const recuperaPermisos = async () => {
            try {
                setCargaPermisos(true);
                const permisos = await getPermisosPan();
                //console.log('MM01:', permisos);
                const arrayTemp = permisos.map(item=>item.nombre)
                //console.log('MM02:', arrayTemp);
                setPermisosBase(arrayTemp)
            } catch (error) {
                console.error('ERROR: ', error.message);
            } finally {
                setCargaPermisos(false);
            }
        };
        recuperaPermisos();
    }, []);

    useEffect(()=> {
        const obtienePantallas = async () => {
            //console.log ('JJ00=', rol)
            if (rol) {
                try {
                    const pantallaDeRol = await getPantallasByRol(rol.configuracionDetId)
                    const listaTMP = pantallaDeRol.map(item => {
                        return {
                            pantallaId: item.pantalla.configuracionDetId,
                            nombre: item.pantalla.nombre,
                            bloques: extraerBloques(item.pantalla.parametro)
                        }
                    })
                    //console.log('kk02=', listaTMP)
                    setPantallas(listaTMP)
                    // consultar el estado inicial
                    const permisosRol = await getPermisosByRol(rol.configuracionDetId)
                    //console.log('kk03=', permisosRol)
                    setPermisosInicio(permisosRol)
                    const permisosIni = generarEstadoInicialPermisos(listaTMP, permisosBase, permisosRol);
                    //console.log('kk04=', permisosIni)
                    setPermisosActuales(permisosIni)
                } catch (error) {
                    console.error('ERROR: ', error.message)
                } finally {
                    //
                }
            }
        }
        obtienePantallas()
    }, [rol, refrescaRol])

    function generarEstadoInicialPermisos(listaPantallas, listaPermisos, permisosGuardados = {}) {
        // El acumulador (acc) sigue siendo el objeto final, inicializado a {}
        const estadoInicial = listaPantallas.reduce((acc, pantalla) => {
            const permisosDePantallaGuardados = permisosGuardados[pantalla.pantallaId] || {};

            // 2. Reduce interno: construir el objeto de permisos para la fila actual
            const permisosParaPantalla = listaPermisos.reduce((permisoAcc, nombrePermiso) => {
                // 3. Lógica de Inicialización:
                const valorGuardado = permisosDePantallaGuardados[nombrePermiso];

                if (valorGuardado !== undefined && valorGuardado !== null) {
                    permisoAcc[nombrePermiso] = valorGuardado;
                } else {
                    permisoAcc[nombrePermiso] = false; // Valor por defecto para nuevos permisos/pantallas
                }

                return permisoAcc;
            }, {});

            acc[pantalla.pantallaId] = permisosParaPantalla;
            return acc;
        }, {});

        return estadoInicial;
    }


    // Función de manejo de cambio
    const handlePermisoChange = (pantallaId, permiso) => {
        setPermisosActuales((prevPermisos) => ({
            ...prevPermisos,
            [pantallaId]: {
                ...prevPermisos[pantallaId],
                [permiso]: !prevPermisos[pantallaId][permiso]
            }
        }));
    };

    // Renderiza la columna de "Pantalla"
    const nombreBodyTemplate = (rowData) => {
        return <span>{rowData.nombre}</span>;
    };

    // Renderiza el Checkbox para una columna de permiso CRUD.
    // Los permisos BLOQUE_* se muestran en la fila expandida, no aqui.
    const permisoBodyTemplate = (rowData, permiso) => {
        const pantallaId = rowData.pantallaId;
        const isChecked = !!permisosActuales[pantallaId]?.[permiso];

        return (
            <div className="p-d-flex p-jc-center">
                <Checkbox inputId={`permiso_${pantallaId}_${permiso}`} checked={isChecked} onChange={() => handlePermisoChange(pantallaId, permiso)} />
            </div>
        );
    };

    // La grilla principal muestra solo permisos no-BLOQUE_* (CRUD). Los BLOQUE_*
    // se muestran al expandir cada fila, lo que evita scroll horizontal cuando
    // hay muchos bloques declarados.
    const permisosCrud = permisosBase.filter(p => !(typeof p === 'string' && p.startsWith('BLOQUE_')));

    // Generar dinámicamente el array de componentes <Column> para los permisos CRUD
    const permisoColumns = permisosCrud.map((permiso) => {
        return (
            <Column
                key={permiso}
                header={permiso}
                body={(rowData) => permisoBodyTemplate(rowData, permiso)}
                style={{ width: '80px', textAlign: 'center' }}
            />
        );
    });

    // Template de fila expandida: lista vertical de checkboxes para los BLOQUE_*
    // declarados en el parametro de esta pantalla.
    const rowExpansionTemplate = (rowData) => {
        const pantallaId = rowData.pantallaId;
        const bloques = Array.isArray(rowData.bloques) ? rowData.bloques : [];
        if (bloques.length === 0) {
            return <div className="px-4 py-2 text-500 text-sm">Esta pantalla no declara bloques.</div>;
        }
        return (
            <div className="px-4 py-3 surface-50 border-round">
                <div className="text-sm font-semibold text-700 mb-2">Bloques de la pantalla</div>
                <div className="grid">
                    {bloques.map(b => {
                        const isChecked = !!permisosActuales[pantallaId]?.[b];
                        return (
                            <div key={b} className="col-12 md:col-6 lg:col-4 flex align-items-center gap-2 py-1">
                                <Checkbox
                                    inputId={`bloque_${pantallaId}_${b}`}
                                    checked={isChecked}
                                    onChange={() => handlePermisoChange(pantallaId, b)}
                                />
                                <label htmlFor={`bloque_${pantallaId}_${b}`} className="text-sm">{b}</label>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    // Solo habilitamos expansion para pantallas con al menos un bloque declarado.
    const allowExpansion = (rowData) => (rowData.bloques || []).length > 0;

    const handleGuardar = async () => {
        if (!rol) {
            toast.current.show({severity:'warn', summary: 'Alerta', detail:'Debe Seleccionar un Rol', life: 3000});
            return 
        }
        try {
            setLoadingGuardar(true)
            const respuesta = await guardarPermisos(rol.configuracionDetId, permisosActuales);
            // proceso realizado
            //console.log('ppp=', respuesta)
            toast.current.show({severity:'success', summary: 'Exito', detail:'Se han registrado los Datos', life: 3000});
            /*setRol()
            setPermisosActuales([])
            setPantallas([])*/
            //console.log('DD01=', rol)
            setRefrescaRol(prev => !prev)
        } catch (err) {
            console.error('ERROR:', 'Error al guardar cambios')
            toast.current.show({severity:'error', summary: 'Error', detail:'No se han guardado los Datos', life: 3000});
        } finally {
            setLoadingGuardar(false)
        }
    }
    
    const handleSelecctionChange = (evt) => {
        //console.log ('kkOO=', evt.value)
        if (filaSeleccion && filaSeleccion.pantallaId === evt.value.pantallaId) {
            setFilaSeleccion()
            return;
        }
        setFilaSeleccion(evt.value)
    }

    const handleBorrar = async () => {
        if(!rol) {
            toast.current.show({severity:'warn', summary: 'Alerta', detail:'Debe Seleccionar un Rol', life: 3000});
            return 
        }
        if (!filaSeleccion) {
            toast.current.show({severity:'warn', summary: 'Alerta', detail:'Debe alguna Pantalla', life: 3000});
            return 
        }
        try {
            const objPost = {
                rolId: rol.configuracionDetId, 
                pantallaId: filaSeleccion.pantallaId
            }
            //console.log('ppp900=', objPost)
            
            setLoadingBorrar(true)
            //return ; 
            const borradoMsg = await borrarPantallaRol(objPost)
            //console.log('ppp901=', borradoMsg)
            toast.current.show({severity:'success', summary: 'Exito', detail:'Se han borrado la Pantalla', life: 3000});
            /*setRol()
            setPermisosActuales([])
            setPantallas([])*/
            setRefrescaRol(prev => !prev)
        } catch (err) {
            console.error('ERROR:', 'Error al Eliminar Pantalla')
            toast.current.show({severity:'error', summary: 'Error', detail:'No se ha podido borrar la Pantala', life: 3000});
        } finally {
            setLoadingBorrar(false)
            setVisibleBorrado(false)
        }
    }

    const abreBorrado = () => {
        if(!rol) {
            toast.current.show({severity:'warn', summary: 'Alerta', detail:'Debe Seleccionar un Rol', life: 3000});
            return 
        }
        if (!filaSeleccion) {
            toast.current.show({severity:'warn', summary: 'Alerta', detail:'Debe alguna Pantalla', life: 3000});
            return 
        }
        setVisibleBorrado(true)
    }

    const abreAdicion = () => {
        //console.log('000=', rol)
        if(!rol) {
            toast.current.show({severity:'warn', summary: 'Alerta', detail:'Debe Seleccionar un Rol', life: 3000});
            return 
        }
        setVisibleAdicion(true)
    }

    const handleAdiciona = async (formData) => {
        //console.log('adicion=', formData)
        if (!rol ) {
            toast.current.show({severity:'warn', summary: 'Alerta', detail:'Debe Seleccionar un Rol', life: 3000});
            return 
        }
        try {
            const objPost = {
                rolId : rol.configuracionDetId,
                pantallaId: formData.pantallaId,
                lstPermisosId: formData.listaPermisos
            }
            const guardado = await guardaPantallaRol(objPost)
            toast.current.show({severity:'success', summary: 'Exito', detail:'Se ha guardado con exito', life: 3000});
            /*setRol()
            setPermisosActuales([])
            setPantallas([])*/
            setRefrescaRol(prev=> !prev)
        } catch (err) {
            console.error('ERROR:', 'Error al Adicionar Pantalla')
            toast.current.show({severity:'error', summary: 'Error', detail:'No se ha podido guardar la Pantala', life: 3000});
        } finally {
            setVisibleAdicion(false)
        }
    }

    return (
        <div className="card">
            <Dialog  header="Borrado Pantalla" visible={visibleBorrado} onHide={() => setVisibleBorrado(false)} style={{ width: '40vw' }} >
                <BorradoPantalla onBorrar={handleBorrar} rol={rol} pantalla={filaSeleccion}/>
            </Dialog>
            <Dialog  header="Adición de Pantalla" visible={visibleAdicion} onHide={() => setVisibleAdicion(false)} style={{ width: '50vw' }} >
                <AdicionPantalla rol={rol} onAdiciona={handleAdiciona} />
            </Dialog>
            <h5>Permisos a Roles</h5>
            <Toast ref={toast} />
            <div className="formgrid grid p-fluid mb-3">
                {/* Lista de roles */}
                <div className="field col-12 md:col-4">
                    <label htmlFor="cboProyecto">Roles</label>
                    {cargaRoles ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown id="cboProyecto" value={rol} onChange={(e) => setRol(e.value)} options={lstRoles} placeholder="Selecciona un rol" optionLabel="nombre" filter showClear />
                    )}
                </div>
                {/* Table de permisos */}
                <div className="field col-12 md:col-8">
                    <DataTable
                        value={pantallas}
                        dataKey="pantallaId"
                        selectionMode="single"
                        onSelectionChange={handleSelecctionChange}
                        expandedRows={expandedRows}
                        onRowToggle={(e) => setExpandedRows(e.data)}
                        rowExpansionTemplate={rowExpansionTemplate}
                    >
                        <Column expander={allowExpansion} style={{ width: '3rem' }} />
                        <Column field="nombre" header="Pantalla" body={nombreBodyTemplate} style={{ width: '200px' }}></Column>
                        {permisoColumns}
                    </DataTable>
                </div>
                <div className="field col-12 md:col-4">
                    <span>{' '}</span>
                </div>
                {/* Fila de botones */}
                <div className="field col-12 md:col-2">
                    <Button label='Guardar' onClick={handleGuardar} loading={loadingGuardar} />
                </div>
                <div className="field col-12 md:col-2">
                    <Button label='Borrar' onClick={abreBorrado} />
                </div>
                <div className="field col-12 md:col-2">
                    <Button label='Adicionar' onClick={abreAdicion} />
                </div>
            </div>
        </div>
    );
};

export default PermisosRoles;
